import { createSlice } from '@reduxjs/toolkit';
import { allFolderAction, getFolderAction } from 'redux/actions/folder';
import folderFlatten from 'utils/folderFlatten';

const initialState = {
  folders: [],
  connections: [],
  datamodels: [],
  loading: false,
  flatFolders: [],
  current: {
    id: null,
    breadcrumbs: [],
    folders: [],
    connections: [],
    datamodels: []
  }
};

// First import your thunk then add thunk lifecycle handlers
export const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    // setCurrentFolder: (state, action) => {

    //   if (action.payload){
    //   state.current = action.payload;
    //   state.current.folders = state.folders.filter((object)=> object.parent_id == action.payload.id)
    //   state.current.connections = state.connections.filter((object)=> object.folder?.id == action.payload.id)
    //   state.current.datamodels = state.datamodels.filter((object)=> object.folder?.id == action.payload.id)
    // } 
    // // else {
    // //   state.current.folders = state.folders
    // //   state.current.connections = state.connections
    // //   state.current.datamodels = state.datamodels
    // // }
    // if (action.payload?.id) {
    //   localStorage.setItem('lastFolder', action.payload?.id);
    // } 
    // else {
    //   localStorage.removeItem('lastFolder');
    // }
    
    // },
  },
  extraReducers: {
    [allFolderAction.pending]: (state) => {
      state.loading = true;
    },
    [allFolderAction.fulfilled]: (state, action) => {
      state.folders = action.payload;
      // state.connections = action.payload.connections;
      // state.datamodels = action.payload.datamodels;
      state.loading = false;
      state.flatFolders = folderFlatten(action.payload);
      // const folder = searchFolder(action.payload.folders, null);
      // folderSlice.caseReducers.setCurrentFolder(state, {payload: folder});
    },
    [allFolderAction.rejected]: (state) => {
      state.loading = false;
    },
    [getFolderAction.pending]: (state) => {
      state.loading = true;
    },
    [getFolderAction.fulfilled]: (state, action) => {

      state.current.folders = action.folders
      state.current.connections = action.connections
      state.current.datamodels = action.datamodels
      state.loading = false;
      // const folder = searchFolder(action.payload.folders, null);
      // folderSlice.caseReducers.setCurrentFolder(state, {payload: folder});
    },
    [getFolderAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const { setCurrentFolder } = folderSlice.actions;
// export the reducer to be passed to configureStore
export default folderSlice.reducer;
